import React from "react";
import { Skeleton } from "@components/Skeleton/Skeleton";

export const ProviderBillNameCellSkeleton: React.FC = () => {
  return (
    <div className="flex flex-row items-center gap-3">
      {/*<div className="relative h-full w-9 shrink-0">*/}
      {/*  <div className="absolute top-1/2 flex h-9 w-9 min-w-[2.25rem] -translate-y-1/2 transform flex-col items-center justify-center rounded-lg border border-grey-light shadow"></div>*/}
      {/*</div>*/}
      <div className="flex min-w-0 flex-1 flex-shrink flex-col gap-0.5">
        <Skeleton className="w-48 text-sm leading-6 md:text-base" />
        <div className="md:hidden">
          <Skeleton variant="rounded" className="h-5 w-32" />
        </div>
      </div>
    </div>
  );
};
